import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";

interface RegistrationConfirmationFieldProps {
  title: string;
  value: string;
  isLoading: boolean;
  hasData: boolean;
}

const RegistrationCell = React.forwardRef<
  HTMLDivElement,
  RegistrationConfirmationFieldProps
>(({ title, value, isLoading, hasData }, ref) => {
  return (
    <>
      {isLoading && <Skeleton height={56} />}
      {hasData && (
        <Box>
          <Typography noWrap variant="body2" color="text.secondary">
            {title}
          </Typography>
          <Typography variant="body1">{value}</Typography>
        </Box>
      )}
    </>
  );
});

RegistrationCell.displayName = "RegistrationCell";

export default RegistrationCell;
